import React from 'react';
import { GraduationCap, Award, Users, Target } from 'lucide-react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-grid">
          <div className="about-image-section">
            
            <div className="image-placeholder">
              <div className="placeholder-content">
               
                <img src='/images/img_834.png' />
              </div>
            </div>
            <div className="about-stats-cards">
              <div className="stat-card">
                <Award className="stat-card-icon" size={24} />
                <div className="stat-card-content">
                  <div className="stat-card-number">10+</div>
                  <div className="stat-card-label">godina iskustva</div>
                </div>
              </div>
              <div className="stat-card">
                <Users className="stat-card-icon" size={24} />
                <div className="stat-card-content">
                  <div className="stat-card-number">100+</div>
                  <div className="stat-card-label">polaznika</div>
                </div>
              </div>
            </div>
          </div>

          <div className="about-content">
            <span className="section-badge">O Nama</span>
            <h2 className="section-title">Profesionalna edukacija i savjetovanje   </h2>
            
            <p className="about-text">
              LookApp - obrt za poduku i savjetovanje je osnovan s ciljem pružanja visokokvalitetnih edukativnih i savjetodavnih usluga. Specijaliziramo se za individualni pristup svakom klijentu, osiguravajući najbolje rezultate.
            </p>

            <p className="about-text">
              S više od 10 godina iskustva u IT-u, održavanju edukacija i savjetovanju gdje se radi s IT stručnjacima, učenicima, studentima i profesionalcima koji žele unaprijediti svoje znanje i vještine. Moj cilj je pomoći klijentima i polaznicima ostvariti edukativne i karijerne ciljeve i puni potencijal.
            </p>

            <div className="about-features">
              <div className="feature-item">
                <div className="feature-icon">
                  <Target size={24} />
                </div>
                <div className="feature-content">
                  <h4>Individualni pristup</h4>
                  <p>za svakoga prema potrebama i ciljevima</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <GraduationCap size={24} />
                </div>
                <div className="feature-content">
                  <h4>Stručnost i iskustvo</h4>
                  <p>u radu s klijentima različitih profila i potreba</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <Award size={24} />
                </div>
                <div className="feature-content">
                  <h4>Potvrđeni rezultati</h4>
                  <p>zadovoljnih polaznika i klijenata</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
